import { popups } from './modules/popups'

window.GetHooked = {}

const afterLoad = () => {
    popups.init()
}

document.addEventListener('DOMContentLoaded', afterLoad)

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
      console.log("Trustwidget HMR")
    })
}
